import Model, { attr } from '@ember-data/model';

export default class AirbnbQualityReviewTrendModel extends Model {
  @attr('date') date!: Date;
  @attr('number') averageReviewScore!: number;
  @attr('number') fiveStarReviewPercentage!: number;
  @attr('number') cleanliness!: number;
  @attr('number') accuracy!: number;
  @attr('number') communication!: number;
  @attr('number') checkin!: number;
  @attr('number') location!: number;
  @attr('number') value!: number;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-quality-review-trend': AirbnbQualityReviewTrendModel;
  }
}
